import { useNavigate, useParams } from 'react-router';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { CUSTOM_TOOLS_PATH, CustomToolBuilder, useCustomTool } from '@/modules/integrations/custom-tools';

/** Creates a custom tool, or edits the one in the URL. */
export default function CustomToolBuilderPage() {
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();
	const { data: tool, isError } = useCustomTool(id ?? '');
	const back = () => navigate(CUSTOM_TOOLS_PATH);

	if (id && !tool) {
		return (
			<div className='flex h-full flex-col'>
				<div className='flex h-[60px] shrink-0 items-center gap-2 border-b border-gray-500 px-4'>
					<Button variant='ghost' size='icon' className='size-7 rounded-full' aria-label='Back to custom tools' onClick={back}>
						<ChevronLeft size={16} />
					</Button>
					<h1 className='text-base font-semibold'>Custom tool</h1>
				</div>
				<div className='mx-auto flex w-full max-w-3xl flex-col gap-3 p-6'>
					{isError ? (
						<p className='py-10 text-center text-sm text-red-500'>Failed to load this custom tool.</p>
					) : (
						Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className='h-24 rounded-xl' />)
					)}
				</div>
			</div>
		);
	}

	return (
		<CustomToolBuilder key={tool?.id ?? 'new'} tool={tool ?? null}>
			<div className='flex h-full flex-col'>
				<CustomToolBuilder.Header title={tool?.name ?? 'New custom tool'} onBack={back} />
				<CustomToolBuilder.Stage />
			</div>
		</CustomToolBuilder>
	);
}
